import styled from "styled-components";

import { Tabs } from "@libraries/mui/components";

import { windowWidth } from "@styles/global";

const StepsContainer = styled(Tabs)`

  min-height: 35px !important;
  width: 100% !important;
  overflow: hidden !important;

  .MuiTabs-scrollButtons.Mui-disabled {
    opacity: 0.3;
  }

  .MuiTabs-scroller {
    .MuiTabs-flexContainer {
      gap: 20px !important;
    }

    .MuiTabs-indicator {
      display: none;
    }
  }
`;

const ControlButtons = styled.div`
  position: fixed;
  right: 16px;
  bottom: 16px;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 5px;
  z-index: 1000;

  .MuiFab-primary {
    background-color: ${(props) => props.theme.brand.navy} !important;
  }

  .MuiFab-success {
    background-color: ${(props) => props.theme.brand.green} !important;
  }

  .MuiFab-sizeLarge {
    min-width: 80px !important;
    height: 80px !important;
  }

  .MuiFab-sizeLarge.additional-control-button {
      border-radius: 40px !important;
  }
 
  .MuiFab-sizeMedium {
    min-width: 60px !important;
    height: 60px !important;
  }

  .MuiFab-sizeMedium.additional-control-button {
      border-radius: 30px !important;
  }

  /* The 80px FAB is oversized on phones — scale the control buttons down. */
  @media ( max-width: ${windowWidth.mobile.large} ) {
    .MuiFab-sizeLarge {
      min-width: 60px !important;
      height: 60px !important;
    }

    .MuiFab-sizeLarge.additional-control-button {
      border-radius: 30px !important;
    }

    .MuiFab-sizeMedium {
      min-width: 48px !important;
      height: 48px !important;
    }

    .MuiFab-sizeMedium.additional-control-button {
      border-radius: 24px !important;
    }
  }
`;

export { StepsContainer, ControlButtons };
